import { useParams } from 'react-router-dom'
import { useSupportArticle, useSupportContent } from '../../config/queries'
import NotFound from '../Error/NotFound'
import { isSupportSectionSlug } from './sections'
import SupportLayout from './SupportLayout'
import SupportArticleContent from './SupportArticleContent'

const SupportArticlePage = () => {
  const { section: sectionParam, slug } = useParams()
  const { data: content } = useSupportContent()
  const {
    data: article,
    isPending,
    isError,
  } = useSupportArticle(sectionParam, slug)

  if (!sectionParam || !slug || !isSupportSectionSlug(sectionParam)) {
    return <NotFound />
  }

  const section = sectionParam
  const articles = content?.articlesBySection[section] ?? []

  if (isPending) return null
  if (isError || !article) return <NotFound />

  return (
    <SupportLayout section={section} articles={articles} title={article.title}>
      <SupportArticleContent content={article.content} />
    </SupportLayout>
  )
}

export default SupportArticlePage
